import Place from '@/models/Place'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    placeDetails: {
      name: '',
      type: null,
      description: '',
      image: null,
      places_address: '',
      google_places_id: null
    }
  },

  mutations: {
    setPlaceList(state, places) {
      each(places, place => {
        const exist = find(state.list, { id: place.id })
        if (!exist) {
          state.list.push(new Place(place))
        }
      })
    },

    clearPlaceList(state) {
      state.list = []
    },

    setPlaceListMeta(state, meta) {
      state.listMeta = meta
    },

    setPlaceDetails(state, place) {
      if (place instanceof Place) {
        state.placeDetails = place
      } else {
        state.placeDetails = new Place(place)
      }
    },

    clearPlaceDetails(state) {
      state.placeDetails = {
        name: '',
        type: null,
        description: '',
        image: null,
        places_address: '',
        google_places_id: null
      }
    }
  },

  actions: {
    clearPlaceDetails({ commit }) {
      commit('clearPlaceDetails')
    },

    async createPlace({ commit }, formData) {
      const { data } = await Api.post(`admin/places`, formData)
      commit('setPlaceDetails', data.data)
    },

    async updatePlace({ commit }, formData) {
      const { data } = await Api.post(
        `admin/places/${formData.get('id')}`,
        formData
      )
      commit('setPlaceDetails', data.data)
    },

    async deletePlace({ commit }, placeId) {
      const { data } = await Api.delete(`admin/places/${placeId}`)
      commit('setPlaceDetails', data.data)
    },

    async getPlaces({ commit }, params) {
      const query = Place.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setPlaceList', res.data)
      commit('setPlaceListMeta', res.meta)
    },

    async getPlaceDetails({ commit }, id) {
      const { data } = await Api.get(`admin/places/${id}`)
      commit('setPlaceDetails', data.data)
    }
  }
}
